<script>

import gql from 'graphql-tag'

const currentUserMetaQuery = gql`
  query {
    currentUser: user {
      guid
      full_name
      email
    }
  }
`
export default {
  apollo: {
    currentUser: {
      query: currentUserMetaQuery
    }
  },
  computed: {
    currentUserName () {
      return this.currentUser?.full_name
    },
    currentUserInitials () {
      return this.$options.filters.initials(this.currentUserName)
    },
    currentUserEmail () {
      return this.currentUser?.email
    }
  }
}
</script>
